import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { withStyles } from "@material-ui/core/styles";
import { Typography, Dialog, Button, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList, IconButton, DialogTitle as MuiDialogTitle } from "@material-ui/core";
import { CompareArrows as CompareArrowsIcon, ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon, Close as CloseIcon } from "@material-ui/icons";

import TransferForm from "./TransferForm";
import TransferCall from "./TransferCall";

import useStyles from "../../styles";
//store
import * as actions from "../../../../store/actions/actionIndex";

const styles = (theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: "absolute",
		insetInlineEnd: "0px",
		top: "0px",
		color: theme.palette.grey[500],
	},
});

const DialogTitle = withStyles(styles)((props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

function TransferCallButton(props) {
	var classes = useStyles();
	const [open, setOpen] = useState(false);
	const [show, setShow] = useState(true);
	const anchorRef = React.useRef(null);
	const [transfer, setTransfer] = useState(null);
	const [transferVal, setTransferVal] = useState(null);
	//const [transferOptions, setTransferOptions] = useState([]);
	const [transferRes, setTransferRes] = useState(false);

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}
		setOpen(false);
	};

	function handleListKeyDown(event) {
		if (event.key === "Tab") {
			event.preventDefault();
			setOpen(false);
		}
	}

	const closeDialog = () => {
		setShow(false);
		props.onUnsetTransfer(props.agentId);
	};

	useEffect(
		() => {
			if (!props.error && !props.loading && props.dataAction && !props.transferAction) {
				if(props.dataAction!=="Agent"){
					setTransfer(props.dataAction);
				}
				setShow(true);
			}
		},
		[props.error, props.loading, props.dataAction, props.transferAction],
		[]
	);

	useEffect(
		() => {
			if (!props.error && !props.loading && !props.dataAction && props.transferAction) {
				setShow(false);
				setTransferRes(true);
			}
		},
		[props.error, props.loading, props.dataAction, props.transferAction],
		[]
	);

	const transferClicked = (e, value) => {
		handleClose(e);
		if (value === "Agent") {
			props.onGetTransferableCampaign(props.agentId);
			//props.onGetTransferableAgents(props.agentId);
			setTransferVal(value);
		} else if (value === "Campaign") {
			props.onGetTransferableCampaign(props.agentId);
			setTransferVal(value);
		}
		if (value === "Extension") {
			props.onGetTransferableExtension(props.agentId);
			setTransferVal(value);
		}
		//setShow(true);
	};
	let transferDiv = "";
	if (transfer && props.dataAction) {
		transferDiv = (
			<div className="transfer-dropdown">
				<Dialog aria-labelledby="customized-dialog-title" open={show} className={classes.DialogBox}>
					<DialogTitle onClose={closeDialog} className={classes.DialogTitleMain}>
						<Typography className={classes.DialogTitle}>Transfer to {transferVal}</Typography>
						<div style={{ padding: "30px 0px 0px 0px" }}>
							<TransferForm transferType={transfer} transferVal={transferVal} />
						</div>
					</DialogTitle>
				</Dialog>
			</div>
		);
	}

	let transferOptions = [];
	if (props.facilityConf.transfer === "0") {
		//setTransferOptions([...transferOptions, 'Agent']);
		transferOptions = [...transferOptions, "Agent"];
	}
	if (props.facilityConf.disable_transferable_campaigns === "0") {
		//setTransferOptions([...transferOptions, 'Campaign']);
		transferOptions = [...transferOptions, "Campaign"];
	}
	if (props.campConf.transfer_to === "1") {
		//setTransferOptions([...transferOptions, 'Extension']);
		transferOptions = [...transferOptions, "Extension"];
	}

	return (
		<div>
			<Button
				ref={anchorRef}
				variant="outlined"
				color="primary"
				aria-controls={open ? "menu-list-grow" : undefined}
				aria-haspopup="true"
				onClick={function() {
					handleToggle();
				}}
				style={{ marginInlineStart: "10px", color: "primary", textTransform: "capitalize", border: "2px solid", height: "36px" }}>
				<CompareArrowsIcon />
				&nbsp;Transfer &nbsp; {!open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
			</Button>

			<Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: "1", width: "176px", paddingInlineEnd: "20px" }}>
				{({ TransitionProps, placement }) => (
					<Grow {...TransitionProps} style={{ transformOrigin: placement === "bottom" ? "center top" : "center bottom" }}>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
									{transferOptions.length &&
										transferOptions.map((item) => (
											<MenuItem key={item} className={classes.MenuListItem} onClick={(e) => transferClicked(e, item)}>
												Transfer To {item}
											</MenuItem>
										))}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
			{transferDiv}
			{transferRes ? <TransferCall transferInfo={props.transferAction} /> : ""}
		</div>
	);
}

const mapStateToProps = (state) => {
	
	return {
		error: state.callTransfer.error,
		loading: state.callTransfer.loading,
		dataAction: state.callTransfer.dataAction,
		transferAction: state.callTransfer.transferAction,
		
		agentId: state.agentData.agentId,
		facilityConf: state.agentConfig.facilityConf,
		campConf: state.agentConfig.campConf,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		
		onGetTransferableCampaign: (agentId) => dispatch(actions.getTransferableCampaign(agentId)),
		onGetTransferableExtension: (agentId) => dispatch(actions.getTransferableExtension(agentId)),
		onUnsetTransfer: (agentId) => dispatch(actions.unsetTransfer(agentId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(TransferCallButton);
